import { useState } from 'react';
import useThreeStore from '@modules/three/hooks/useThreeStore.ts';
import { IconButton } from '@/components/ui/button';
import HalfEdgeMesh from '@/modules/three/common/halfEdgeMesh/HalfEdgeMesh.js';

export function FillHole() {
  const { rootState } = useThreeStore();
  const [isActive, setIsActive] = useState(false);

  async function fillHole() {
    rootState.scene.children.forEach(async (child) => {
      // Check if child is of type HalfEdgeMesh
      if (child instanceof HalfEdgeMesh) {
        console.log('Found HalfEdgeMesh, applying advancing front algorithm...');

        // Apply the advancing front hole filling algorithm
        await child.advancingFront(0.15);
      }
    });
  }

  if (!isActive) {
    return <IconButton onClick={() => setIsActive(true)}>Fill Holes</IconButton>;
  }

  return (
    <>
      <div className={'bg-content p-4 text-white flex flex-col justify-center rounded-2xl'}>
        <h2 className="text-lg font-semibold mb-4">Fill Holes</h2>
        <IconButton
          onClick={() => {
            fillHole();
          }}
        >
          Apply Hole Filling
        </IconButton>
      </div>
    </>
  );
}
